import { render, staticRenderFns } from "./PolicyRuleTarget.vue?vue&type=template&id=60f08c18&"
import script from "./PolicyRuleTarget.vue?vue&type=script&lang=js&"
export * from "./PolicyRuleTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports